// removed by extract-text-webpack-plugin
module.exports = {"locations":"src-templates----Homepage-module---locations---2z23s","services":"src-templates----Homepage-module---services---3XCnU"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/Homepage.module.scss
// module id = ./src/templates/Homepage.module.scss
// module chunks = 10013748475682